// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-FormBuilder-Widgets-SuggestionAutocompleteTextbox-module__field";
var _2 = "webpack-concepts-Extraction-FormBuilder-Widgets-SuggestionAutocompleteTextbox-module__labelInput";
export { _1 as "field", _2 as "labelInput" }
